import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { App } from './App';
import './styles/global.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

if (!GOOGLE_CLIENT_ID) {
  console.error('Google Client ID is not set in environment variables');
  throw new Error('Google Client ID must be set in environment variables');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <GoogleOAuthProvider 
          clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ''}
          onScriptLoadSuccess={() => {
            console.log('Google OAuth initialized successfully');
          }}
          onScriptLoadError={() => {
            console.error('Failed to load Google OAuth script');
          }}
        >
          <SubscriptionProvider>
            <App />
          </SubscriptionProvider>
        </GoogleOAuthProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>
);